import React from 'react';
import { motion } from 'framer-motion';
export function CoverHero() {
  return <section className="relative min-h-screen bg-solventum-dark overflow-hidden flex flex-col" data-id="element-21">
      {/* Vertical line — scales down from top & bottom toward middle */}
      <motion.div className="absolute top-0 bottom-0 w-px bg-solventum-green/60 origin-center" style={{
      right: '22%'
    }} initial={{
      scaleY: 0,
      opacity: 0
    }} animate={{
      scaleY: 1,
      opacity: 1
    }} transition={{
      duration: 1.4,
      delay: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }} aria-hidden="true" data-id="element-22" />

      {/* Long horizontal line — draws inward from left toward the vertical line */}
      <motion.div className="absolute left-0 h-px bg-solventum-green/60 origin-left" style={{
      bottom: '12%',
      right: '22%'
    }} initial={{
      scaleX: 0,
      opacity: 0
    }} animate={{
      scaleX: 1,
      opacity: 1
    }} transition={{
      duration: 1.2,
      delay: 1.1,
      ease: [0.22, 1, 0.36, 1]
    }} aria-hidden="true" data-id="element-23" />

      {/* Short horizontal continuation — draws to the right edge */}
      <motion.div className="absolute h-px bg-solventum-green/60 origin-left" style={{
      bottom: '12%',
      left: '78%',
      right: 0
    }} initial={{
      scaleX: 0,
      opacity: 0
    }} animate={{
      scaleX: 1,
      opacity: 1
    }} transition={{
      duration: 0.9,
      delay: 1.5,
      ease: [0.22, 1, 0.36, 1]
    }} aria-hidden="true" data-id="element-24" />

      {/* Bottom-right horizontal accent */}
      <motion.div className="absolute h-px bg-solventum-green/60 origin-right" style={{
      bottom: '6%',
      right: 0,
      width: '22%'
    }} initial={{
      scaleX: 0,
      opacity: 0
    }} animate={{
      scaleX: 1,
      opacity: 1
    }} transition={{
      duration: 0.8,
      delay: 1.7,
      ease: [0.22, 1, 0.36, 1]
    }} aria-hidden="true" data-id="element-25" />

      {/* Logo */}
      <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="relative z-10 pt-10 md:pt-14 px-8 md:px-16" data-id="element-26">
        <img src="https://cdn.magicpatterns.com/uploads/qHCwY7wts3zVy5vRBDiXqD/solventum-logo-vert-clr-rev-rgb.png" alt="Solventum" className="h-10 md:h-12 w-auto" data-id="element-27" />
      </motion.div>

      {/* Main content */}
      <div className="relative z-10 flex-1 flex items-center px-8 md:px-16" data-id="element-28">
        <div className="max-w-4xl" data-id="element-29">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.15
        }} className="text-solventum-green text-sm md:text-base font-medium tracking-[0.15em] uppercase mb-8" data-id="element-30">
            Clinical peer learnings
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.25
        }} className="text-white font-semibold leading-[1.05] tracking-tight text-5xl md:text-7xl lg:text-[5.5rem] mb-10" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-31">
            Every case begins with a challenge.
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.45
        }} className="text-white/80 text-lg md:text-xl max-w-2xl leading-relaxed" data-id="element-32">
            A peer-led treasure chest of use cases and actual experience.
          </motion.p>
        </div>
      </div>
    </section>;
}